import Quill, { Parchment } from "quill";
import { createRoot } from "react-dom/client";

import { EntityPill } from "src/copilot/EntityPill";
import { EventPill } from "src/copilot/EventPill";
import { NodePill } from "src/copilot/NodePill";
import { isEntity, isEvent, MentionedResource } from "src/copilot/quillUtils";

const Embed = Quill.import("blots/embed") as typeof Parchment.EmbedBlot;

const renderMentionPill = (resource: MentionedResource) => {
  const container = document.createElement("span");
  container.style.display = "inline-flex";
  container.style.verticalAlign = "middle";
  const root = createRoot(container);

  if (isEntity(resource)) {
    root.render(<EntityPill resource={resource} />);
  } else if (isEvent(resource)) {
    root.render(<EventPill resource={resource} />);
  } else {
    root.render(<NodePill node={resource} />);
  }
  return container;
};

export class MentionBlot extends Embed {
  static readonly blotName: string = "mention";
  static readonly tagName: string = "span";
  static readonly className: string = "inline-flex align-middle";

  static create(resource: MentionedResource) {
    const span = renderMentionPill(resource);

    let mappedResource;

    if (isEntity(resource) || isEvent(resource)) {
      mappedResource = {
        id: resource.id,
        value: resource.value,
      };
    } else {
      mappedResource = {
        id: resource.id,
        value: resource.data.label,
      };
    }

    span.contentEditable = "false";
    span.setAttribute("data-id", mappedResource.id);
    span.setAttribute("data-value", mappedResource.value);
    return span;
  }

  static value(node: HTMLElement) {
    return {
      id: node.getAttribute("data-id"),
      value: node.getAttribute("data-value"),
    };
  }
}
